import React, { useState, memo, ReactElement } from "react";

import JSONPretty from "react-json-pretty";

import { LogBoxItem } from "models";
import { makeStyles, createStyles } from "@material-ui/styles";
import { ValmetAlarm, ValmetWarning, ValmetCommonHighlight, ValmetGreen1 } from "theme";

const localStyles = makeStyles(() =>
  createStyles({
    logItem: {
      padding: "10px",
      marginBottom: "1rem",
      borderWidth: "1px",
      borderRadius: "3px",
      borderStyle: "solid",
      "&:last-child": {
        marginBottom: 0
      }
    },
    logItemHeader: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "10px",
    },
    logItemHeaderText: {
      width: "100%",
      paddingLeft: "10px",
      lineHeight: "24px",
    },
    error: {
      color: ValmetAlarm,
      borderColor: ValmetAlarm,
    },
    info: {
      color: ValmetCommonHighlight,
      borderColor: ValmetCommonHighlight,
    },
    warning: {
      color: ValmetWarning,
      borderColor: ValmetWarning,
    },
    success: {
      color: ValmetGreen1,
      borderColor: ValmetGreen1,
    },
    showMoreButton: {
      background: "transparent",
      border: "unset",
      padding: "unset",
      textDecoration: "underline",
      cursor: "pointer",
    },
    jsonContainer: {
      color: "black",
    },
  }),
);

interface Props {
  logItem: LogBoxItem;
  icon: ReactElement;
}

const LogItem: React.FC<Props> = ({ logItem, icon }) => {
  const localClasses = localStyles();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={`${localClasses[logItem.severity]} ${localClasses.logItem}`}>
      <div className={localClasses.logItemHeader}>
        {icon}
        <div className={localClasses.logItemHeaderText}>{logItem.data?.startTime}</div>
      </div>
      <p>{logItem.text}</p>

      {logItem.data && (
        <button type="button" onClick={() => setIsOpen(!isOpen)} className={localClasses.showMoreButton}>
          {isOpen ? "Show less" : "Show more"}
        </button>
      )}
      {isOpen && <div className={localClasses.jsonContainer}>{<JSONPretty id="json-pretty" data={logItem.data}></JSONPretty>}</div>}
    </div>
  );
};

export default memo(LogItem);
